"use strict";

class DeveloperLeadTransferController {

  constructor($scope, $window, $localStorage, SSHttpService, SSUtilService, SSAppService, SSUserService, SSAlertService) {
    const self = this;

    self.$scope = $scope;
    self.$window = $window;
    self.$storage = $localStorage;

    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSAppService = SSAppService;
    self.SSUserService = SSUserService;
    self.SSAlertService = SSAlertService;

    // Broker roles in a project team
    self.PROJECT_BROKER_TYPE_TEAMLEAD = SHOWSUITE.PROJECT_BROKER_TYPE_TEAMLEAD;  // 1

    self.data = SHOWSUITE.data;
    self.lead_id = self.data.lead_id;
    self.property_id = self.data.property_id;

    self.brokers = [];
    self.selectedBroker = null;

    self.has_access = false;
    if (self.SSUserService.isDeveloper()) {
        self.init();
        self.has_access = true;
    }
  }

  init() {
    const self = this;

    self.user = self.SSUserService.getUser();
    if (!self.SSUserService.getUser()) {
      self.SSUserService.showLoginModal();
    }

  }

  getBrokers(){
    const self = this;

    self.selectedBroker = null;
    self.searchFieldError = '';
    self.noRecord = '';

    if(!self.criteria){
      self.searchFieldError = 'Please enter a value to search agent(s)';
      return;
    }

    let url = 'brokers/search';
    let params = {
      'property_id': parseInt(self.property_id),
      'role': self.PROJECT_BROKER_TYPE_TEAMLEAD,
      'criteria': self.criteria
    };

    loading(true);
    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
      loading(false);
      if (response instanceof Error) {
          self.SSAlertService.parseAndDisplayError(response);
          return;
      }
      console.log('response.data');
      console.log(response.data);
      if(jQuery.isEmptyObject(response.data.agents)){
        self.noRecord = 'No record found';
      }
      self.brokers = response.data.agents;
    });
  }

  updateBroker(user_id){
    const self = this;

    _.each(self.brokers, function(broker){
      if(broker.user_id == user_id){
        self.selectedBroker = broker;
      }
    });
  }

  removeBroker(){
    const self = this;

    self.selectedBroker = null;
  }

  onConfirmTransfer() {
    const self = this;

    self.hideModal();

    if(!self.selectedBroker){
      self.SSAlertService.danger('Error!', 'Please select an agent to proceed');
      return;
    }

    self.showModal = true;
    $('#confirmLeadTransferModal').modal('show');

  }

  updateLeadTransfer(){
    const self = this;

    let url = 'sec/developer/leads/' + parseInt(self.lead_id) + '/transfer';
    let params = {
      broker_user_id: self.selectedBroker.user_id,
      remarks: self.remarks
    };

    loading(true);
    self.SSHttpService.postAPIRequest(url, params).then(function (response) {
        loading(false);
        if (response instanceof Error) {
          if (response.sub_code == 307002) {
            self.SSAlertService.danger("Error!", response.message);
            return;
          }
          self.SSAlertService.parseAndDisplayError(response);
          // let message = response.data.broker_user_id[0];
          // self.SSAlertService.danger('Error!', message);

          return;
        }

        self.SSAlertService.success('Success!', 'Lead transferred successfully');

        // Redirect to previous page
        self.$window.location.href = '/developer/leads';
        
    });
  }

  hideModal() {
    const self = this;

    self.showModal = false;

    if ($('#confirmLeadTransferModal').is(':visible')) $('#confirmLeadTransferModal').modal('hide');
  }

}

DeveloperLeadTransferController.$inject = ['$scope', '$window', '$localStorage', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSAlertService'];
app.controller('DeveloperLeadTransferController', DeveloperLeadTransferController);